import { render, staticRenderFns } from "./tabOverseaBill.vue?vue&type=template&id=2d108f83&"
import script from "./tabOverseaBill.vue?vue&type=script&lang=js&"
export * from "./tabOverseaBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d108f83')) {
      api.createRecord('2d108f83', component.options)
    } else {
      api.reload('2d108f83', component.options)
    }
    module.hot.accept("./tabOverseaBill.vue?vue&type=template&id=2d108f83&", function () {
      api.rerender('2d108f83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabOverseaBill.vue"
export default component.exports